import React from "react";
import ContactList from "../../../_components/Contacts/ContactList";
import {
    getSuppliers, getSupplierKpis, deleteSupplier,
    AREAS, STATUSES, SEARCH_TYPES,
} from "../../../_services/contact.service";
import { isPurchasingUser, isSuperAdmin, canAccessAccounting } from '../../../utils/roleConstants';

export default function Suppliers() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // BUM can only view — hide create button
    const viewOnly = !(isSuperAdmin(user) || isPurchasingUser(user) || canAccessAccounting(user));
    return (
        <ContactList
            title="Supplier List"
            type="Supplier"
            fetchList={getSuppliers}
            fetchKpis={getSupplierKpis}
            deleteItem={deleteSupplier}
            hideCreate={viewOnly}
            viewOnly={viewOnly}
            AREAS={AREAS}
            STATUSES={STATUSES}
            SEARCH_TYPES={SEARCH_TYPES}
        />
    );
}